<template>
  <div class="platform-page">
    <div class="platform-bg"></div>
    <div class="platform-container">
      <div class="platform-card">
        <div class="platform-logo">
          <img src="@/assets/logo_blue.png" alt="logo" class="logo-img">
        </div>
        <div class="platform-title">真保供应商平台</div>
        <el-form :model="formData" :rules="rules" ref="formRef" class="platform-form">
          <el-form-item prop="username">
            <el-input
              v-model="formData.username"
              placeholder="用户名"
              class="input-item"
              size="large"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="formData.password"
              type="password"
              placeholder="密码"
              class="input-item"
              size="large"
              show-password
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="large"
              class="submit-btn"
              :loading="loading"
              @click="handleSubmit"
            >
              绑定账号
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { ElMessage } from 'element-plus'
import crypto from 'crypto-es';
import _service from '@/api/index'

const formRef = ref();
const loading = ref(false);

const formData = reactive({
  username: '',
  password: ''
});

const rules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' }
  ]
};

const handleSubmit = () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true;
      const params = {
        password: crypto.MD5(formData.password),
        username: formData.username,
        grant_type: 'customer_password',
        group_id: "101",
      };
      try {
        const res = await _service.loginCustomer(params);
        if(res.access_token) {
          ElMessage.success('绑定成功');
        } else {
          res.errmsg && ElMessage.error(res.errmsg);
          loading.value = false;
        }
      } catch (error) {
        loading.value = false;
      }
    }
  });
};
</script>

<style lang="less" scoped>
.platform-page {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  box-sizing: border-box;
}

.platform-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('@/assets/m_bg2.jpg') no-repeat center center;
  background-size: cover;
  z-index: -1;
}

.platform-container {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.platform-card {
  width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 40px 30px 30px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  position: relative;
}

.platform-logo {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  width: 70px;
  height: 70px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.logo-img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.platform-title {
  text-align: center;
  font-size: 18px;
  color: #374151;
  margin-bottom: 30px;
  margin-top: 10px;
}

.platform-form {
  width: 100%;
}

.input-item {
  width: 100%;
  height: 48px;
  border-radius: 8px;
}

.submit-btn {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 500;
  background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  
  &:hover, &:focus {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  }
}

.platform-footer {
  margin-top: 40px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  
  p {
    margin: 4px 0;
  }
}
</style>